import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../Api/Endpoints";

export const fetchSalutationData = createAsyncThunk(
  "api/salutation",
  async () => {
    const token = localStorage.getItem("other");
    const response = await fetch(EndPoints.PRISM_GET_SALUTATION, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  }
);

const departmentSlice = createSlice({
  name: "salutation",
  initialState: {
    salutationdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSalutationData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSalutationData.fulfilled, (state, action) => {
        state.loading = false;
        state.salutationdata = action.payload?.data || [];
      })
      .addCase(fetchSalutationData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default departmentSlice.reducer;